(function () {
  class PaytablePopup extends PIXI.Container {
    constructor() {
      super();

      this.active = false;

      this.sounds = [
        'winline', // l5
        'winline', // l4
        'winline', // l3
        'winline', // l2
        'winline', // l1
        'meow1', // h5
        'meow2', // h4
        'meow3', // h3
        'meow4', // h2
        'meow5', // h1
        'standardWild', // wild
        'bonusLand1', // bonus
      ];

      this.offsets = {
        left: { x: 178, y: 47 },
        right: { x: -52, y: 47 },
      };

      this.symbolOffsets = {
        1: {
          10: { x: 8.5, y: 8.5 },
          11: { x: 22, y: 22 },
        },
        2: {
          10: { x: 17, y: 17 },
          11: { x: 0, y: 22 },
        },
        3: {
          10: { x: 25.5, y: 25.5 },
          11: { x: 22, y: 22 }, // dont care as we wil trigger fs and you wont be able to touch
        },
      };

      this.selectedOffsets = null;
      this.visible = false;

      this.currentMovie = null;
      this.lastSymbolClicked = null;
      this.timer = null;
    }

    init() {
      messageBus.subscribe('game:symbolTouched', (data) => {
        this.onSymbolTouched(data);
      });
      this.hide();
    }

    hide() {
      if (this.timer) {
        timerManager.stop(this.timer);
        this.timer = null;
      }

      if (this.currentMovie) {
        this.currentMovie.gotoAndStop(0);
        this.currentMovie = null;
      }

      this.lastSymbolClicked = null;
      this.turnOffAllSymbols();
      this.visible = false;
    }

    onSymbolTouched(data) {
      console.log('PaytablePopup-onSymbolTouched');

      if (this.lastSymbolClicked === data.symbolTouched) {
        this.lastSymbolClicked = null;
        this.hide();
        messageBus.postImmediate('game:paytablePopupRemoved');
      } else {
        messageBus.postImmediate('game:paytablePopupShown');
        this.lastSymbolClicked = data.symbolTouched;

        if (this.timer) {
          timerManager.stop(this.timer);
          this.timer = null;
        }

        if (this.currentMovie) {
          this.currentMovie.gotoAndStop(0);
          this.currentMovie = null;
        }

        this.turnOffAllSymbols();

        const reel = data.reel;
        const symbolTouched = data.symbolTouched;
        const symId = data.symId;

        const stage = systemData.stage;
        const convertedCoords = this.toLocal(symbolTouched.toGlobal(stage));
        console.log('onSymbolTouched - newCoords = ', convertedCoords);

        const leftSide = resourceManager.get('slotContainer:paytablePopup:PaytablePopup:panel:leftHandSide');
        const rightSide = resourceManager.get('slotContainer:paytablePopup:PaytablePopup:panel:rightHandSide');
        leftSide.visible = false;
        rightSide.visible = false;

        if (this.sounds[symId] !== null) {
          soundManager.play(this.sounds[symId]);
        }

        // 318 is the x i get when i click on 3rd reel
        // will add a few pixels for safety
        // or we use the blockDistribution along with reel number to know for sure, but
        // its a lot of data for no need
        if (convertedCoords.x > 340) {
          // we need to put the symbol on the right hand side
          this.selectedOffsets = this.offsets.right;
          rightSide.visible = true;
          this.turnOnRightSymbol(symId);
        } else {
          // symbol can be on the left hand side
          this.selectedOffsets = this.offsets.left;
          leftSide.visible = true;
          this.turnOnLeftSymbol(symId);
        }

        const panel = resourceManager.get('slotContainer:paytablePopup:PaytablePopup:panel');
        panel.x = convertedCoords.x + this.selectedOffsets.x;
        panel.y = convertedCoords.y + this.selectedOffsets.y;
        if (convertedCoords.y < 0) {
          panel.y += 126;
        }
        if (this.symbolOffsets[reel._blockSize][symId]) {
          panel.x += this.symbolOffsets[reel._blockSize][symId].x;
          panel.y += this.symbolOffsets[reel._blockSize][symId].y;
        }

        this.visible = true;

        this.timer = timerManager.addTimeout(3000, () => {
          this.hide();
          messageBus.postImmediate('game:paytablePopupRemoved');
        });
      }
    }

    turnOffAllSymbols() {
      this.turnOffAllLeftSymbols();
      this.turnOffAllRightSymbols();
    }

    turnOffAllLeftSymbols() {
      for (let i = 0; i < Globals.NUM_SYMBOLS; i++) {
        this.turnOffLeftSymbol(i);
      }
    }
    turnOffLeftSymbol(symId) {
      const containerName = `slotContainer:paytablePopup:PaytablePopup:panel:leftHandSide:${symId}`;
      const container = resourceManager.get(containerName);
      container.visible = false;
      const symbolName = `slotContainer:paytablePopup:PaytablePopup:panel:leftHandSide:${symId}:symbol`;
      const symbol = resourceManager.get(symbolName);
      symbol.gotoAndStop(0);
    }
    turnOnLeftSymbol(symId) {
      const containerName = `slotContainer:paytablePopup:PaytablePopup:panel:leftHandSide:${symId}`;
      const container = resourceManager.get(containerName);
      container.visible = true;
      const symbolName = `slotContainer:paytablePopup:PaytablePopup:panel:leftHandSide:${symId}:symbol`;
      const symbol = resourceManager.get(symbolName);
      symbol.gotoAndPlay(0);
      this.currentMovie = symbol;
    }

    turnOffAllRightSymbols() {
      for (let i = 0; i < Globals.NUM_SYMBOLS; i++) {
        this.turnOffRightSymbol(i);
      }
    }
    turnOffRightSymbol(symId) {
      const containerName = `slotContainer:paytablePopup:PaytablePopup:panel:rightHandSide:${symId}`;
      const container = resourceManager.get(containerName);
      container.visible = false;
      const symbolName = `slotContainer:paytablePopup:PaytablePopup:panel:leftHandSide:${symId}:symbol`;
      const symbol = resourceManager.get(symbolName);
      symbol.gotoAndStop(0);
    }
    turnOnRightSymbol(symId) {
      const containerName = `slotContainer:paytablePopup:PaytablePopup:panel:rightHandSide:${symId}`;
      const container = resourceManager.get(containerName);
      container.visible = true;
      const symbolName = `slotContainer:paytablePopup:PaytablePopup:panel:rightHandSide:${symId}:symbol`;
      const symbol = resourceManager.get(symbolName);
      symbol.gotoAndPlay(0);
      this.currentMovie = symbol;
    }
  }

  var creator = function (json) {
    return new PaytablePopup();
  };

  var initialise = function (json, obj) {};

  var filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('PaytablePopup', creator, initialise, filesRequired);
})();
